import { useEffect, useState } from "react";

// A cosmetic "the app is running" ticker for the landing page.
// Events are illustrative — not tied to any real business data.
const TICKER_EVENTS = [
  { name: "Party of 4 · Chen",     action: "added by Mimi",   time: "12s",  status: "queued" },
  { name: "Party of 2 · Alvarez",  action: "notified · SMS",  time: "34s",  status: "notify" },
  { name: "Inbound call",          action: "Ring 2 → Mimi",   time: "1m",   status: "live"   },
  { name: "Party of 6 · Kim",      action: "seated · T-12",   time: "2m",   status: "seated" },
  { name: "SMS · 'on our way'",    action: "auto-reply sent", time: "3m",   status: "notify" },
  { name: "Party of 3 · Patel",    action: "added by Mimi",   time: "4m",   status: "queued" },
  { name: "Walk-in · Ortiz",       action: "seated · T-7",    time: "5m",   status: "seated" },
];

const STATUS_STYLE = {
  queued: "bg-[#F5C543] text-[#121914]",
  notify: "bg-[#C2D1C1] text-[#1E3A2F]",
  live:   "bg-[#D96C5B] text-white",
  seated: "bg-[#1E3A2F] text-[#F5C543]",
};

export const LiveDot = ({ color = "#F5C543", size = 2 }) => (
  <span className="relative inline-flex" style={{ width: `${size * 4}px`, height: `${size * 4}px` }}>
    <span className="absolute inset-0 rounded-full animate-ping opacity-75" style={{ background: color }} />
    <span className="relative rounded-full w-full h-full" style={{ background: color }} />
  </span>
);

export default function LiveTicker({ dark = false, compact = false }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % TICKER_EVENTS.length), 2400);
    return () => clearInterval(t);
  }, []);
  const e = TICKER_EVENTS[i];
  return (
    <div
      data-testid="live-ticker"
      className={`inline-flex items-center gap-2.5 font-mono text-[11px] leading-none whitespace-nowrap ${
        dark ? "text-[#C2D1C1]" : "text-[#5C6B61]"
      } ${compact ? "" : "px-3 py-1.5 rounded-full ring-1 " + (dark ? "ring-white/10 bg-white/5" : "ring-black/5 bg-white/60 backdrop-blur")}`}
    >
      <LiveDot color={dark ? "#F5C543" : "#D96C5B"} />
      <span className={`tracking-[0.22em] uppercase font-semibold ${dark ? "text-[#F5C543]" : "text-[#D96C5B]"}`}>Live</span>
      <span className={`px-1.5 py-0.5 rounded text-[9px] font-bold uppercase ${STATUS_STYLE[e.status]}`}>{e.status}</span>
      <span className={dark ? "text-white" : "text-[#121914]"}>{e.name}</span>
      <span className="opacity-60 hidden sm:inline">— {e.action}</span>
      <span className="opacity-40 hidden md:inline">· {e.time} ago</span>
    </div>
  );
}
